import { graphqlClient } from '../client';

// Mutation for toggling the mapping of a charge to a version
const TOGGLE_CHARGE_MAPPING_MUTATION = `
  mutation ToggleChargeVersionMapping($input: ToggleChargeMappingInput!) {
    toggleChargeVersionMapping(input: $input) {
      success
      message
      charge_id
      added
      removed
    }
  }
`;

// TypeScript interfaces
export interface ToggleChargeMappingInput {
  charge_id: string;
  slug: string;
  version: string;
  page_id: string;
}

export interface ToggleChargeMappingResult {
  success: boolean;
  message: string;
  charge_id: string;
  added: boolean;
  removed: boolean;
}

/**
 * Toggle whether a charge is mapped to a specific version
 * If the charge is already mapped to the version, it will be unmapped, otherwise it will be mapped
 */
export async function toggleChargeMappingMutation(input: ToggleChargeMappingInput): Promise<ToggleChargeMappingResult> {
  try {
    console.log(`🔄 [GraphQL] Toggling mapping for charge ${input.charge_id} in version ${input.version}`);
    
    const data = await graphqlClient.request<{ toggleChargeVersionMapping: ToggleChargeMappingResult }>(
      TOGGLE_CHARGE_MAPPING_MUTATION,
      { input }
    );
    
    if (!data || !data.toggleChargeVersionMapping) {
      console.error('❌ [GraphQL] No data returned from toggleChargeVersionMapping mutation');
      throw new Error('No data returned from server');
    }
    
    console.log(
      `✅ [GraphQL] Successfully ${data.toggleChargeVersionMapping.added ? 'added' : 'removed'} charge mapping`, 
      data.toggleChargeVersionMapping
    );
    
    return data.toggleChargeVersionMapping;
  } catch (error) {
    console.error('❌ [GraphQL] Unexpected error in toggleChargeMappingMutation:', error);
    throw error;
  }
}
